import { API } from "@/constants/common";
import { apiClient } from "./client/apiClient";

export const uploadApi = {
  list: async (params) => {
    return apiClient.get(API.UPLOAD.LIST, {
      ...params,
    });
  },
  detailFile: async (fileId: number, params) => {
    return apiClient.get(API.UPLOAD.DETAIL_FILE(fileId), {
      ...params,
    });
  },
  create: async (data) => {
    return apiClient.post(API.UPLOAD.CREATE, data);
  },
  updateMapping: async (fileId: number, data) => {
    return apiClient.post(API.UPLOAD.UPDATE_MAPPING(fileId), data);
  },
  validateMapping: async (fileId: number, data) => {
    return apiClient.post(API.UPLOAD.VALIDATE_MAPPING(fileId), data);
  },
  fileError: async (fileId: number) => {
    return apiClient.get(API.UPLOAD.FILE_ERROR(fileId));
  },
  detail: async (fileId: number) => {
    return apiClient.get(API.UPLOAD.DETAIL(fileId));
  },
  downfile: async (fileId: number) => {
    return apiClient.get(API.UPLOAD.DOWN_FILE(fileId));
  },
};
